import { createContext, useContext } from 'react';
import { Language } from '../types/language';

export interface LanguageContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (stringId: string, content?: Record<string, string>) => string;
}

const LanguageContext = createContext<LanguageContextValue>({
  language: Language.EN,
  setLanguage: () => {},
  t: stringId => stringId,
});

export default LanguageContext;

export const useLanguage = () => useContext(LanguageContext);
